"use strict";

exports.__esModule = true;
exports.ActionButtonHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Core = require("../../Core");
var _common = require("../common");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Displays a header for ActionButton.
 */
var ActionButtonHeader = exports.ActionButtonHeader = function ActionButtonHeader(props) {
  return /*#__PURE__*/_react["default"].createElement(_Core.Heading, {
    level: 4,
    ellipsize: true,
    style: Object.assign({}, (0, _common.getWidgetCSSProps)(props), {
      lineHeight: (props.height || 30) + "px",
      flex: 1
    })
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ActionButtonHeader.headingActionButton",
    defaultMessage: "Action Button"
  }));
};